/**
 * Number — formats numeric values for display in data tables.
 *
 * Handles: percentage conversion (decimal -> %), divisor scaling (e.g., /1000 for thousands),
 * and locale-aware formatting with configurable decimal places via column.decimals.
 * Returns raw value for non-numeric columns like "Reference Date".
 */
const Number = ({ value, column, factor, isRounded, isPercentage }) => {
    if(column === "Reference Date") return value;
    if(!value) return value;
    value = parseFloat(value);
    if(factor) value = value / factor; // Scale by divisor (e.g., factor=1000 to show thousands)
    if(isPercentage) {
        const PctFormatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        return PctFormatter.format(100 * value) + "%";
    }
    const dec = column && column.decimals != null ? column.decimals : 0;
    if(dec === 0) value = Math.round(value);
    const Formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: dec,
        maximumFractionDigits: dec
    });
    return Formatter.format(value);
};

export default Number;